module.exports = __webpack_public_path__ + "assets/c6e819f49f4c376d6a9aa7c4e6983c72.png";